import '../../estilos/paginas.css';
import { useEffect, useState } from 'react';
import { useNavigate, useParams, useLocation } from "react-router-dom";
import 'swiper/swiper-bundle.css'; // Importa los estilos de Swiper
import { Navigation, Pagination, Autoplay } from 'swiper/modules';
import { Swiper, SwiperSlide } from 'swiper/react';
import axios from "axios";
// componentes
import ZonaCargando from '../zonaCargando';
import RegistrarParaVer from './registrarParaVer';
import ContenedorTorneos from './contenedorTorneos';
import ContenedorPartidos from './contenedorPartidos';
// clases
import "swiper/css";
import 'swiper/css/autoplay';

function Home() {
  const navigate    = useNavigate();
 
  const [torneos, setTorneos]   = useState(null);
  const [videos, setVideos]     = useState(null);
  const [partidos, setPartidos] = useState(null);
  const [cargando, setCargando] = useState(true);
  const [usuario, setUsuario]   = useState(null);


  // Modificar la clase de body par página de registro - styles.css /////////
  useEffect(() => {
    setCargando(true);
    const verifToken  = axios.get("/verificar-token", {  withCredentials: true  });
    const videosReq   = axios.post("/obtener-ultimos-videos", { params: { deporte: "futbol" } });
    const partidosReq = axios.post("obtener-ulitmos-partidos");
    const imagenesReq = axios.post("/obtener-logos");

    Promise.all([verifToken, videosReq, partidosReq, imagenesReq])
    .then(([resVerif, resVideos, resPartidos, resImagenes]) => {
      //console.log("resverifo: ", resVerif);
      setUsuario(resVerif.data.usuario);
      setVideos(resVideos.data.videos); 
      setPartidos(resPartidos.data.partidos); 
      // torneo
      setTorneos(resImagenes.data.torneos); 
    })
    .catch((err) => {  console.error("Error al inicializar:", err); })
    .finally(() => { setCargando(false); });
  }, []);
  // Modificar la clase de body par página de registro - styles.css /////////
  

  async function verVideo(video){
    
    const nombreEquipoUnoURL = video.nombreEquipoUno.toLowerCase().replace(/\s+/g, '-');
    const nombreEquipoDosURL = video.nombreEquipoDos.toLowerCase().replace(/\s+/g, '-');

    let nombrePartido = nombreEquipoUnoURL + "-vs-" + nombreEquipoDosURL;
    let urlAverVideo = "/video/" + video.video.idVideo; 

    // Navegar y forzar la recarga
    navigate(urlAverVideo );
    window.location.reload();  // Esto forzará la recarga completa de la página
  } 

  

  return(
  <div>
    {cargando ? <ZonaCargando /> : 
    <div>
    {/* 1. slider iniciar */}
    <div className='contenedor-home'>
      <Swiper
      modules={[Autoplay]}
      spaceBetween={0}
      slidesPerView={1}
      autoplay={{ delay: 2500, disableOnInteraction: false, }}
      loop={true}
      className="slider-fondo"
      >
        <SwiperSlide>
          <div className="slide">
            <img src="https://bucket-web-general-comolavio.s3.us-east-2.amazonaws.com/imagenes-web/1.png" alt="slide" className="slide-image" />
          </div>
        </SwiperSlide>
        <SwiperSlide>
          <div className="slide">
            <img src="https://bucket-web-general-comolavio.s3.us-east-2.amazonaws.com/imagenes-web/2.png" alt="slide" className="slide-image" />
          </div>
        </SwiperSlide>
        <SwiperSlide>
          <div className="slide">
            <img src="https://bucket-web-general-comolavio.s3.us-east-2.amazonaws.com/imagenes-web/3.png" alt="slide" className="slide-image"/>
          </div>
        </SwiperSlide>
      </Swiper>
    </div>
    
    {/* 2 y 3 */}
    <div className='fondoContenedorUno py-5'>
      {/* 2. Video corporativos */}
      <div className='container text-light'>
        <h1 className="text-center my-5 text-light"> <span style={{color: "#00c7ca"}} >Cómo la vió</span> - La pasión no para al finalizar el juego</h1>
        {/* Contendor video */}
        <div className='container my-5'>
          <div className='container text-center d-flex align-items-center justify-content-center '>
            <div className="container-fluid text-light">
              <video 
                className="claseVideoHome"
                controls
                autoPlay={false}
              >
                <source src="https://bucket-web-general-comolavio.s3.us-east-2.amazonaws.com/videos/clv.mp4" type="video/mp4" />
                Tu navegador no soporta la etiqueta de video.
              </video>
            </div>
          </div>
        </div>
        {/* fotos y textos */}
        <div className='row'>
          {/* columna 1 */}
          <div className='col-lg-3'>
            <img className='imgCorporativos' src={`https://bucket-web-general-comolavio.s3.us-east-2.amazonaws.com/imagenes-web/7.jpeg?date=${Date.now()}`}  alt="conoce cómo la vio"></img>
            <h3 className='mt-4 mb-2'>1. Conoce Comó la vió</h3>
            <p style={{ textAlign: 'justify' }} >Somos la plataforma para deportistas no profesionales con el contenido deportivo más emocionante del mundo, tus propias jugadas, videos de tus mejores momentos en competencia.</p>
          </div>

          {/* columna 2 */}
          <div className='col-lg-3'>
            <img className='imgCorporativos' src={`https://bucket-web-general-comolavio.s3.us-east-2.amazonaws.com/imagenes-web/5.jpeg?date=${Date.now()}`} alt='lo que hacemos'></img>
            <h3 className='mt-4 mb-2'>2. Lo que hacemos</h3>
            <p style={{ textAlign: 'justify' }} >Subimos en nuestra plataforma 20 videos (aprox.), con grabaciones de 22 segundos, los mejores momentos del partido que acabas de jugar, para que los puedas ver y compartir  las veces que quieras con tus amigos y familiares.</p>
          </div>

          {/* columna 3 */}
          <div className='col-lg-3'>
            <img className='imgCorporativos'src={`https://bucket-web-general-comolavio.s3.us-east-2.amazonaws.com/imagenes-web/4.jpeg?date=${Date.now()}`} alt='cómo lo hacemos'></img>
            <h3 className='mt-4 mb-2'>3. Cómo lo hacemos</h3>
            <p style={{ textAlign: 'justify' }} >Con nuestra tecnología podrás registrar en nuestro sistema los goles , atajadas , oportunidades de gol y jugadas destacadas de tu partido, las cuales quedarán disponibles en la zona correspondiente al torneo en el que participas, algunos minutos después que termines de jugar, sin necesidad de edición. Navega nuestra web, busca la fecha que quieres en la zona de tu torneo y ve todas las jugadas del partido, todas las veces que quieras. Puedes pedir que uno de nuestros narradores comente algunas de tus jugadas.</p>
          </div>

          {/* columna 4 */}
          <div className='col-lg-3'>
            <img className='imgCorporativos' src={`https://bucket-web-general-comolavio.s3.us-east-2.amazonaws.com/imagenes-web/6.jpeg?date=${Date.now()}`} alt='nuestros resultados'></img>
            <h3 className='mt-4 mb-2'>4. Nuestros resultados</h3>
            <p style={{ textAlign: 'justify' }} >Mira aquí algunos momentos destacados de deportistas que siguen disfrutando y reviviendo la emoción de su pasión.</p>
          </div>
        </div>
      </div>
    

      {/* 3. Carrusel de videos */}
      {(videos)
      ? <div className='mx-1'>
      <h2 className="text-center my-5 text-light"> <span style={{color: "#00c7ca"}} >Videos Destacados</span> - ¿Cómo la vió?</h2>
        <Swiper
          spaceBetween={10} // Espacio entre los slides
          navigation // Habilita los botones de navegación
          pagination={{ clickable: true }} // Habilita la paginación
          autoplay={{
            delay: 3000, // Tiempo en ms entre transiciones
            disableOnInteraction: false, // No detener el autoplay después de la interacción
          }}
          modules={[Navigation, Pagination, Autoplay]} // Incluye los módulos
          breakpoints={{
            640: {
              slidesPerView: 1, // Muestra 1 video en pantallas pequeñas
            },
            768: {
              slidesPerView: 2, // Muestra 2 videos en pantallas medianas
            },
            1024: {
              slidesPerView: 4, // Muestra 4 videos en pantallas grandes
            },
        }}
        >
          {videos.map((video, index) => (
            <SwiperSlide key={index}>
              <div
                className="video-thumbnail"
                style={{
                  position: 'relative',
                  cursor: 'pointer',
                  textAlign: 'center', // Centra el texto debajo del video
                }}
                onClick={() => verVideo(video)} // Llama a la función al hacer clic
              >
                {/* Contenedor del video con overlay */}
                <div style={{ position: 'relative', borderRadius: '8px', overflow: 'hidden' }}>
                  <img
                    src={video.video.urlImagen || ""}
                    alt={`Video ${video.video.idVideo}`}
                    className="d-block w-100"
                    style={{ borderRadius: '8px' }} // Estilo opcional para el borde
                  />
                  {/* Overlay para el video */}
                  <div
                    style={{
                      position: 'absolute',
                      top: 0,
                      left: 0,
                      right: 0,
                      bottom: 0,
                      background: 'rgba(0, 0, 0, 0.5)', // Fondo oscuro
                      color: 'white',
                      display: 'flex',
                      justifyContent: 'center',
                      alignItems: 'center',
                      opacity: 0.7,
                      borderRadius: '8px', // Para que coincida con la imagen
                    }}
                  >
                    <h5>Ver Video</h5>
                  </div>
                </div>


                {/* Descripción del video */}
                <div className="d-flex justify-content-center align-items-center my-2 text-light">
                  <p className="textosDescripcionUno text-center me-2 mb-0"><strong>{video.video.equipo}</strong></p>
                  <p className="textosDescripcionUno text-center me-2 mb-0">{video.video.tipo}</p>
                  {/* me gusta */}
                  <div className="d-flex align-items-center me-2 text-light">
                    <i className="textosDescripcionUno bi bi-heart  me-1"></i>
                    <p className="textosDescripcionUno text-center mb-0">{video.video.meGusta.length}</p>
                  </div>
              
                  {/* Vistas */}
                  <div className="d-flex align-items-center me-2 text-light">
                    <i className="textosDescripcionUno bi bi-play me-1"></i>
                    <p className="textosDescripcionUno text-center mb-0">{video.video.vistas}</p>
                  </div>
                </div>

                {/* Descripción 2*/}
                <div className='mt-3 text-light' >
                  <p className="textosDescripcionDos text-center me-2 mb-0">
                    {video.nombreEquipoUno + " vs " + video.nombreEquipoDos}
                  </p>
                  <p className="textosDescripcionDos text-center me-2 mb-0">{video.torneo}</p>
                  <p className="textosDescripcionDos text-center me-2 mb-0">{video.nombreEstadio}</p>
                </div>
              </div>
            </SwiperSlide>
          ))}
        </Swiper>
      </div>
      : null
      }
    </div>


    {/* 4. Patrocinadores */}
    <div className='container text-light py-5'>
      <h2 className="text-center my-5 text-light"> <span style={{color: "#00c7ca"}} >Sponsors</span> - Quienes lo hacen posible</h2>
      <div className='row'>
        {/* columna 1 */}
        <div className='col-lg-3'>
        <a href='https://wa.me/573132957130' target='_blank' rel='noreferrer' ><img className='imgCorporativos' src='https://bucket-web-general-comolavio.s3.us-east-2.amazonaws.com/imagenes-web/a.jpg' alt="conoce cómo la vio"></img></a>
          <h3 className='mt-4 mb-2'>Knowmads</h3>
          <p style={{ textAlign: 'justify' }} >Somos distribuidores de los productos orgánicos que tiene como prioridad el Bienestar 
          Con la garantía NutriCert™️, cada producto botánico refleja el compromiso inquebrantable con la calidad y la trazabilidad. Descubre la confianza que te mereces en nuestra tienda online.
          </p>
          <p><strong>Whatsapp: 3132957130</strong></p>
        </div>

        {/* columna 2 */}
        <div className='col-lg-3'>
          <a href='https://www.tecnomarketingweb.com' target='_blank' rel='noreferrer' ><img className='imgCorporativos' src='https://bucket-web-general-comolavio.s3.us-east-2.amazonaws.com/imagenes-web/b.jpg' alt='lo que hacemos'></img></a>
          <h3 className='mt-4 mb-2'>Tecnomarketingweb</h3>
          <p style={{ textAlign: 'justify' }} >¿Quieres que tu marca se destaque en el mundo digital? Tecnomarketingweb es tu aliado perfecto. Con expertos en diseño de páginas web y posicionamiento SEO, te ayudamos a:

          •⁠  ⁠Diseñar páginas web profesionales que atraen y convierten visitantes en clientes.
          •⁠  ⁠Mejorar tu visibilidad en Google con estrategias de SEO efectivas.
          •⁠  ⁠Incrementar tus ventas con una presencia online sólida y atractiva.
          </p>
          <p><strong>www.tecnomarketingweb.com.co Whatsapp: 3002818925</strong></p>
        </div>

        {/* columna 3 */}
        <div className='col-lg-3'>
          <a href='https://wa.me/5732145274160' target='_blank' rel='noreferrer' ><img className='imgCorporativos' src='https://bucket-web-general-comolavio.s3.us-east-2.amazonaws.com/imagenes-web/d.jpg' alt='cómo lo hacemos'></img></a>
          <h3 className='mt-4 mb-2'>Esviernes.co</h3>
          <p style={{ textAlign: 'justify' }} >Pon tus activaciones de marca y lanzamientos en manos expertas.  Sabemos de la importancia que tiene cada acción que realizas, por eso las asumimos y ejecutamos con el esmero y profesionalismo que tú mereces.</p>
          <p><strong>Whatsapp: 3214527416</strong></p>
        </div>

        {/* columna 4 */}
        <div className='col-lg-3'>
          <a href='https://www.pretwor.com' target='_blank' rel='noreferrer' ><img className='imgCorporativos' src='https://bucket-web-general-comolavio.s3.us-east-2.amazonaws.com/imagenes-web/e.jpg' alt='nuestros resultados'></img></a>
          <h3 className='mt-4 mb-2'>Pretwor</h3>
          <p style={{ textAlign: 'justify' }} >Desarrollamos tu proyecto a medida, ya sea una aplicación web o móvil. Nos encargamos de convertir tus ideas en realidad utilizando las herramientas tecnológicas más avanzadas y código de vanguardia.</p>
          <p><strong>WhatsApp: 322 429 4332</strong></p>
        </div>
      </div>
    </div>

    {/* 5. Publicidad */}
    <div className='container mb-5'>
      <a href="https://wa.me/573132957130">
        <img  className="imagen-hover-123" style={{width: "100%"}} src='https://bucket-web-general-comolavio.s3.us-east-2.amazonaws.com/logos/Anuncios2.png'></img>
      </a>
    </div>


    
    {/* 6 y 7 */}
    <div className='py-1 my-5' style={{backgroundColor: "#131631"}}>
      {/* 6. imagenes equipos */}
      <div className='container'>
        <div className='row align-items-center' style={{ minHeight: '40vh' }}>
          {/* texto */}
          <div className='col-lg-4 d-flex align-items-center'>
            <div>
              <h2 style={{ color: "#00c7ca" }}>
                Filtra tus <span className="text-white">clips favoritos</span>. Por equipo, partido o deporte.
              </h2>
              <p className='text-light'>
                Sabemos que es clave poder encontrar rápidamente tus clips favoritos y por esto ponemos a tu disposición un amplio filtro para tu beneficio. <br /><br />
                Sabemos lo que te gusta y por esto en las preferencias de tu cuenta podrás determinar lo que más te gustaría ver dentro de todos los clips de la plataforma.
              </p>
            </div>
          </div>

          {/* logos */}
          {torneos &&
          <div className='col-lg-8 align-items-center'>
            <div className="row">
              {torneos.map((tor, index) => (
                <div className="col-3 mb-4 text-center" key={index}>
                  <a href={tor.enlace}>
                  < img src={tor.imagen} alt={`logo ${index}`} className="img-fluid" style={{ maxHeight: '200px' }} />
                  </a>
                </div>
              ))}
            </div>
          </div>
          }
        </div>
      </div>

      {/* 7. filto */}

    
    </div>

    {/* Contenedor torneos */}
    {/* <ContenedorTorneos torneos={torneos} /> */}
    <ContenedorPartidos partidos={partidos} />

    {usuario ? null : <RegistrarParaVer /> }
    </div>
    }
  </div>
  )
}



export default Home;